import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import QuotesModalContent from './QuotesModalContent';
const QuotesModal = {
    /**
     * `onStartNewQuote` is supplied by the entry hook rather than resolved here,
     * so that a new quote reuses saved details when it can — and so the modal
     * does not have to reach back into the hook that opened it.
     */
    show: (url, onStartNewQuote) => {
        Modal.show(<QuotesModalContent url={url} onStartNewQuote={onStartNewQuote} hideModal={(cb) => Modal.hide(cb)}/>, {
            containerStyle: styles.modal,
            title: 'Your quotes',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
export default QuotesModal;
